import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {MarketingHeader} from './MarketingHeader'

registerReactPartial('marketing-header', {
  Component: MarketingHeader,
})
